/**
 * Signup variant copy and behavior – drawer/confirmation text and flags keyed by variant.
 * Backend sends variant (e.g. 'favorites', 'chat'); we use these defaults when rendering.
 */

import { LogoVariant } from '@landtrustinc/design-system';

export type SignupVariantData = {
  header: string;
  subtext: string;
  drawerHeader: string;
  drawerSubtext: string;
  confirmationPrimary: string;
  confirmationSecondary: string;
  logoVariant?: LogoVariant;
};

export const SIGNUP_VARIANT_DEFAULTS: Record<string, SignupVariantData> = {
  favorites: {
    header: "Don't lose this property!",
    subtext: 'Create a free account to save this property and view it later on any device.',
    drawerHeader: 'Create your free LandTrust account.',
    drawerSubtext: "You're one step away from saving this package and getting more help from Buck.",
    confirmationPrimary: "I've saved this property to your favorites.",
    confirmationSecondary: "You've successfully created your free LandTrust account.",
  },
  default: {
    header: "Don't lose this property!",
    subtext: 'Create a free account to save this property and view it later on any device.',
    drawerHeader: 'Create your free LandTrust account.',
    drawerSubtext: "You're one step away from saving this package and getting more help from Buck.",
    confirmationPrimary: "I've saved this property to your favorites.",
    confirmationSecondary: "You've successfully created your free LandTrust account.",
  },
  ltplus: {
    header: 'Sign in to continue',
    subtext: '',
    drawerHeader: 'Sign in to continue',
    drawerSubtext: '',
    confirmationPrimary: "You're all set!",
    confirmationSecondary: "You've successfully signed in.",
    logoVariant: 'plus',
  },
};

export function getSignupVariantData(variant?: string): SignupVariantData {
  const key = variant && variant in SIGNUP_VARIANT_DEFAULTS ? variant : 'default';
  const data = SIGNUP_VARIANT_DEFAULTS[key];
  return { ...data };
}
